/** Copy dictionaries for the plugin marketplace Settings section. */
/** Simplified Chinese dictionary and key source of truth. */
export const zh = {
    tab: '插件市场',
    loading: '正在读取插件目录…',
    error: '暂时无法读取插件目录。',
    retry: '重试',
    refresh: '刷新目录',
    search: '搜索插件',
    empty: '目录暂时是空的。',
    emptySearch: '没有匹配的插件。',
    synced: '目录已同步',
    // Tiers
    tierVerifiedNpm: 'npm 已验证',
    tierVerifiedGit: '源码已验证',
    tierLikely: '疑似插件',
    tierRelated: '生态相关',
    // Filters and sort
    filterAll: '全部',
    filterInstallable: '可一键安装',
    filterInstalled: '已安装',
    sortScore: '按评分',
    sortStars: '按 Star',
    sortUpdated: '按更新',
    // Capability badges
    badgeWebUi: '含界面',
    badgeSkills: '含 Skills',
    badgeApiKey: '需 API Key',
    badgeBuild: '安装时构建',
    // Capability labels (closed tag vocabulary, translated subset)
    capMemory: '记忆',
    capMultiAgent: '多智能体',
    capWebSearch: '联网搜索',
    capMcpBridge: 'MCP 桥接',
    capCliCompanion: 'CLI 伴侣',
    capOcr: 'OCR',
    capFileOps: '文件操作',
    // Category labels (closed category vocabulary)
    catCoding: '编码开发',
    catBrowserWeb: '浏览器与 Web',
    catDataAnalysis: '数据分析',
    catMediaImage: '图像与多媒体',
    catMediaAudioVideo: '音视频',
    catProductivity: '效率',
    catCommunication: '通讯',
    catDevopsInfra: '运维与基建',
    catSearchKnowledge: '搜索与知识',
    catUiExperience: '界面体验',
    catAgentOrchestration: '智能体编排',
    catSecurity: '安全',
    catOther: '其他',
    // Actions and state
    install: '安装',
    uninstall: '卸载',
    installed: '已安装',
    installing: '正在安装…',
    uninstalling: '正在卸载…',
    pendingReload: '待刷新',
    manualOnly: '手动安装',
    viewRepo: '仓库',
    countSuffix: '个插件',
    moreBelow: '向下滚动加载，还有 ',
    moreBelowSuffix: ' 条',
    hiddenPrefix: '另有 ',
    hiddenSuffix: ' 个匹配的条目被「可一键安装」筛掉了，点这里看全部',
    // Detail panel
    backToList: '返回列表',
    summaryLabel: 'AI 摘要',
    topicsTitle: '仓库话题',
    topicSearch: '点击以搜索该话题',
    tagsTitle: '分类与标签',
    metricsTitle: '仓库指标',
    willRun: '将执行的命令',
    authorHint: '作者 README 里写的',
    notExecuted: '不会执行',
    notInstallable: '— 市场不提供一键安装',
    evidenceNpm: 'npm 清单声明了 dsh.bundle',
    evidenceGit: '仓库声明 dsh.bundle 且 cordis.patch.yml 有效（安装时会构建）',
    evidenceNone: '无法证明可无人值守安装',
    reloadWebUi: '含 Web 界面，安装后刷新页面即可生效。',
    reloadHostOnly: '仅宿主端插件，安装后立即热挂载。',
    manualBody: '这个插件没有可直接安装的产物，需要克隆后自行构建：',
    readmeTitle: 'README.md',
    viewOnGithub: '在 GitHub 查看',
    readmeUnavailable: '没有读到这个仓库的 README。',
    readmeMeta: '由市场抓取并缓存',
    forks: 'Fork',
    commits: '提交',
    openIssues: '开放 Issue',
    closedIssues: '已关闭',
    openPrs: '开放 PR',
    created: '创建于',
    language: '主要语言',
    npmVersion: 'npm 版本',
    latestRelease: '最新发布',
    // Relative time
    ageToday: '今天',
    ageDays: ' 天前',
    ageMonths: ' 个月前',
    ageYears: ' 年前',
    // Empty state
    emptyHint: '试试换个关键词，或者切换到「全部」再找一次。',
    emptyClear: '清空筛选',
    // Confirm dialog
    confirmTitle: '确认安装',
    willRunConfirm: '将执行（与 dsh plugin add 相同）：',
    confirmBody: '安装会在当前 profile 里写入这个依赖并挂载它。包本身的代码会在你的机器上运行，且不在任何沙箱内。请确认你信任这个来源。',
    confirmBuild: '这个插件没有发布到 npm，安装时会从源码构建并执行仓库自带的构建脚本。',
    confirmCancel: '取消',
    confirmOk: '我已了解，继续安装',
    // Banners
    reloadNeeded: '插件已安装。刷新页面以加载它的界面。',
    reloadNow: '刷新页面',
    upgradeRequired: '插件目录的格式比当前版本新，请升级 @nanmicoder/dsh-plugin-market。',
    installDisabled: '当前配置已关闭安装功能（allowInstall: false），仅供浏览。',
    sourceSeed: '正在使用内置的种子目录。',
    sourceCache: '正在使用本地缓存的目录。',
    sourceRemote: '目录为在线最新版本',
    // Clipboard
    copy: '复制',
    copied: '已复制',
    // Metadata labels
    stars: 'Star',
    updated: '更新于',
    generatedAt: '目录生成于',
    license: '许可证',
    noLicense: '无许可证',
};
/** English dictionary checked against the Chinese key set. */
export const en = {
    tab: 'Marketplace',
    loading: 'Loading the plugin catalog…',
    error: 'The plugin catalog is unavailable right now.',
    retry: 'Retry',
    refresh: 'Refresh catalog',
    search: 'Search plugins',
    empty: 'The catalog is empty.',
    emptySearch: 'No plugins match.',
    synced: 'Catalog synced',
    tierVerifiedNpm: 'Verified on npm',
    tierVerifiedGit: 'Verified from source',
    tierLikely: 'Likely plugin',
    tierRelated: 'Related',
    filterAll: 'All',
    filterInstallable: 'One-click',
    filterInstalled: 'Installed',
    sortScore: 'By score',
    sortStars: 'By stars',
    sortUpdated: 'By updated',
    badgeWebUi: 'Has web UI',
    badgeSkills: 'Ships skills',
    badgeApiKey: 'Needs API key',
    badgeBuild: 'Builds on install',
    capMemory: 'Memory',
    capMultiAgent: 'Multi-agent',
    capWebSearch: 'Web search',
    capMcpBridge: 'MCP bridge',
    capCliCompanion: 'CLI companion',
    capOcr: 'OCR',
    capFileOps: 'File ops',
    catCoding: 'Coding',
    catBrowserWeb: 'Browser & web',
    catDataAnalysis: 'Data analysis',
    catMediaImage: 'Media & image',
    catMediaAudioVideo: 'Audio & video',
    catProductivity: 'Productivity',
    catCommunication: 'Communication',
    catDevopsInfra: 'DevOps & infra',
    catSearchKnowledge: 'Search & knowledge',
    catUiExperience: 'UI & experience',
    catAgentOrchestration: 'Agent orchestration',
    catSecurity: 'Security',
    catOther: 'Other',
    install: 'Install',
    uninstall: 'Uninstall',
    installed: 'Installed',
    installing: 'Installing…',
    uninstalling: 'Uninstalling…',
    pendingReload: 'Reload pending',
    manualOnly: 'Manual only',
    viewRepo: 'Repository',
    countSuffix: 'plugins',
    moreBelow: 'Scroll for more — ',
    moreBelowSuffix: ' left',
    hiddenPrefix: '',
    hiddenSuffix: ' more matches are hidden by “One-click” — show all',
    backToList: 'Back to list',
    summaryLabel: 'AI summary',
    topicsTitle: 'Repository topics',
    topicSearch: 'Search for this topic',
    tagsTitle: 'Category & tags',
    metricsTitle: 'Repository metrics',
    willRun: 'Command that will run',
    authorHint: 'What the author wrote in the README',
    notExecuted: 'never executed',
    notInstallable: '— not installable from the marketplace',
    evidenceNpm: 'npm manifest declares dsh.bundle',
    evidenceGit: 'Repo declares dsh.bundle + valid cordis.patch.yml (build runs on install)',
    evidenceNone: 'No provable unattended install path',
    reloadWebUi: 'Ships a web UI — reload the page after installing.',
    reloadHostOnly: 'Host-only plugin — hot-mounts immediately.',
    manualBody: 'This plugin ships no directly installable artifact. Clone and build it first:',
    readmeTitle: 'README.md',
    viewOnGithub: 'View on GitHub',
    readmeUnavailable: 'No README could be read for this repository.',
    readmeMeta: 'fetched and cached by the market',
    forks: 'Forks',
    commits: 'Commits',
    openIssues: 'Open issues',
    closedIssues: 'Closed',
    openPrs: 'Open PR',
    created: 'Created',
    language: 'Language',
    npmVersion: 'npm version',
    latestRelease: 'Latest release',
    ageToday: 'today',
    ageDays: 'd ago',
    ageMonths: 'mo ago',
    ageYears: 'y ago',
    emptyHint: 'Try a different term, or switch to “All” and search again.',
    emptyClear: 'Clear filters',
    confirmTitle: 'Confirm install',
    willRunConfirm: 'Will run (same as dsh plugin add):',
    confirmBody: 'Installing writes this dependency into the current profile and mounts it. The package’s own code runs on your machine, outside any sandbox. Only continue if you trust the source.',
    confirmBuild: 'This plugin is not published to npm. Installing builds it from source and runs the repository’s own build script.',
    confirmCancel: 'Cancel',
    confirmOk: 'I understand, install',
    reloadNeeded: 'Plugin installed. Reload the page to load its interface.',
    reloadNow: 'Reload',
    upgradeRequired: 'The published catalog is newer than this build understands. Update @nanmicoder/dsh-plugin-market.',
    installDisabled: 'Installing is disabled by configuration (allowInstall: false). Browsing only.',
    sourceSeed: 'Showing the packaged seed catalog.',
    sourceCache: 'Showing the locally cached catalog.',
    sourceRemote: 'Catalog is live and up to date',
    copy: 'Copy',
    copied: 'Copied',
    stars: 'Stars',
    updated: 'Updated',
    generatedAt: 'Catalog generated',
    license: 'License',
    noLicense: 'No license',
};
